import React, { useState } from 'react';

// Compact icon button matching the TimelinesPage toolbar style: a borderless
// 26×26 square, muted by default, gold on hover/active, with a dark tooltip
// above. `danger` tints it red (for destructive actions like delete).
const GOLD = 'var(--brio-gold, #9F902A)';
const MUTED = 'var(--brio-text-muted, #888)';

export function ToolbarIcon({ onClick, tooltip, active, disabled, danger, children }) {
  const [hovered, setHovered] = useState(false);
  const color = disabled
    ? 'var(--brio-border, #ccc)'
    : danger
      ? (hovered ? '#a94442' : '#bf8b8a')
      : (active || hovered ? GOLD : MUTED);
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={tooltip}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 26, height: 26, padding: 0, border: 'none', background: 'transparent',
        cursor: disabled ? 'default' : 'pointer', color, transition: 'color 0.15s',
        position: 'relative', borderRadius: 3, flexShrink: 0,
      }}
    >
      {children}
      {hovered && tooltip && !disabled && (
        <span style={{
          position: 'absolute', bottom: 'calc(100% + 4px)', left: '50%', transform: 'translateX(-50%)',
          padding: '3px 8px', background: '#333', color: '#fff', fontSize: 10,
          whiteSpace: 'nowrap', pointerEvents: 'none', zIndex: 500, borderRadius: 3,
          fontFamily: 'Raleway, sans-serif',
        }}>
          {tooltip}
        </span>
      )}
    </button>
  );
}

// Thin vertical rule for separating icon groups in a toolbar.
export function ToolbarDivider() {
  return <span style={{ width: 1, alignSelf: 'stretch', background: 'var(--brio-border-subtle, #e5e5e5)', margin: '0 0.15rem' }} />;
}

export default ToolbarIcon;
